/**
 * SSO page views
 */
export enum SSOPageView {
  LOADING = 'loading',
  SIGNUP_EMAIL = 'signup_email',
  ERROR = 'error',
}

/**
 * SSO providers
 */
export enum ProviderName {
  TESLA = 'tesla',
  SMARTCAR = 'smartcar',
  VOLVO = 'volvo',
}
export { ProviderName as SSOProvider };

export type Provider = {
  id: number;
  name: ProviderName;
  disabled: boolean;
  supports_sso: boolean;
};

/**
 * SSO actions
 */
export enum SSOAction {
  SIGNUP = 'signup',
  LOGIN = 'login',
  CONNECT = 'connect',
  RECONNECT = 'reconnect',
}

/**
 * Object representing an internal redirect URI for SSO completion
 */
export type InternalRedirectURI = { path: string; params: { [param: string]: string } };

/**
 * Object representing the state passed to/from SSO providers
 */
export type SSOState = {
  provider: ProviderName;
  make: string;
  action: SSOAction;
  internalRedirect: InternalRedirectURI;
  extra?: any;
};
